import { Layout, message } from 'antd';
import React from 'react'
import Helmet from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Colors from '../assets/themes/colors';
import { appIdentifier, appName, getLocal, removeLocal } from '../globalFunctions/api';
const {Header} = Layout

function GlobalHeader(props) {
  const {title} = props || ''

  const navigate = useNavigate();

  return (
    <Header className="header">
      <Helmet>
        <meta charSet="utf-8" />
        <title>   {`${title} || ${appName}`}   </title>
      </Helmet>
      <div className="logo" />
      <div style={{position :'absolute', left:50}} onClick={()=>{removeLocal(appIdentifier, message?.success('تم تسجيل الخروج')); navigate('/')}} >
          <h3 style={{color:Colors.clear, cursor:'pointer'}}>(تسجيل الخروج )  - {getLocal(appIdentifier)?.user?.username}</h3>
      </div>
    </Header>
  )
}

export default GlobalHeader

